/**
 * Custom JS
 * Minified version of this file is used in production (https://github.com/Josee9988/MinifyAll)
 * Recommendations: do not edit theme.js.liquid to ease theme updates
 * @author @MaxDesignFR
 */

/* ════════════════════════════════════════════════════════════════════════ */
/* #region(collapsed) Product Quick Add */
/**
 * We modify the product Quick Add behavior to not hide on footer intersect
 * in desktop because of its custom top position
 */
import { ProductQuickAdd } from "//medmassager.com/cdn/shop/t/178/assets/theme.js?v=131274085018437209241773436316";
class CustomProductQuickAdd extends ProductQuickAdd {
  #intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));
  connectedCallback() {
    this._scopeFrom = document.getElementById(this.getAttribute('form'));
    this._scopeTo = document.querySelector('.footer');
    if (!this._scopeFrom || !this._scopeTo) return;
    this.#intersectionObserver.observe(this._scopeFrom);
    if (this.mobile) this.#intersectionObserver.observe(this._scopeTo);
  }
  get mobile() {
    return matchMedia(`${themeVariables.breakpoints['sm-max']}`).matches;
  }
}
customElements.define('custom-product-quick-add', CustomProductQuickAdd);
/* #endregion ═════════════════════════════════════════════════════════════ */

/* ════════════════════════════════════════════════════════════════════════ */
/* #region(collapsed) Quantity Controls */
/**
 * Enhanced quantity controls with increment/decrement buttons
 */
class QuantityControls {
  constructor() {
    this.processing = new Set(); // Множество для отслеживания обрабатываемых элементов
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateButtonStates();
  }

  bindEvents() {

    this.removeAllEventListeners();
    

    const decreaseBtns = document.querySelectorAll('.quantity-btn--decrease');
    const increaseBtns = document.querySelectorAll('.quantity-btn--increase');
    

    decreaseBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleClick(e, 'decrease'), { once: false });
    });
    
    increaseBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleClick(e, 'increase'), { once: false });
    });


    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('quantity-input')) {
        this.updateButtonStates();
      }
    });
  }

  removeAllEventListeners() {

    const allBtns = document.querySelectorAll('.quantity-btn');
    allBtns.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });
  }

  handleClick(event, action) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.currentTarget;
    const lineKey = button.dataset.lineKey;
    

    if (this.processing.has(lineKey)) {
      return;
    }
    
    const input = document.querySelector(`.quantity-input[data-line-key="${lineKey}"]`);
    if (!input) {
      console.log('Input not found for lineKey:', lineKey);
      return;
    }

    try {
 
      this.processing.add(lineKey);
      

      this.disableButtons(lineKey);
      
      let currentValue = parseInt(input.value) || 1;
      const maxValue = parseInt(input.max) || Number.MAX_VALUE;
      const minValue = parseInt(input.min) || 1;

      if (action === 'decrease') {
        currentValue = Math.max(minValue, currentValue - 1);
      } else if (action === 'increase') {
        currentValue = Math.min(maxValue, currentValue + 1);
      }

  
      input.value = currentValue;
      
  
      const lineItem = input.closest('line-item');
      if (lineItem && lineItem.querySelector('[is="quantity-input"]')) {
 
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
      } else {
     
        this.updateQuantityViaAPI(lineKey, currentValue);
      }
      

      this.updateButtonStates();
      

      setTimeout(() => {
        this.processing.delete(lineKey);
        this.updateButtonStates();
      }, 500);
      
    } catch (error) {
      console.error('Error updating quantity:', error);
      this.processing.delete(lineKey);
      this.updateButtonStates();
    }
  }
  
  async updateQuantityViaAPI(lineKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });
      
      if (response.ok) {
        const cartData = await response.json();
        // Trigger cart update event
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { cart: cartData }
        }));
      }
    } catch (error) {
      console.error('Error updating quantity via API:', error);
    }
  }

  disableButtons(lineKey) {
    const decreaseBtn = document.querySelector(`.quantity-btn--decrease[data-line-key="${lineKey}"]`);
    const increaseBtn = document.querySelector(`.quantity-btn--increase[data-line-key="${lineKey}"]`);
    
    if (decreaseBtn) decreaseBtn.disabled = true;
    if (increaseBtn) increaseBtn.disabled = true;
  }

  updateButtonStates() {
    const quantityInputs = document.querySelectorAll('.quantity-input');
    
    quantityInputs.forEach(input => {
      try {
        const lineKey = input.dataset.lineKey;
        const currentValue = parseInt(input.value) || 1;
        const minValue = parseInt(input.min) || 1;
        const maxValue = parseInt(input.max) || Number.MAX_VALUE;
        const isProcessing = this.processing.has(lineKey);
        
        const decreaseBtn = document.querySelector(`.quantity-btn--decrease[data-line-key="${lineKey}"]`);
        const increaseBtn = document.querySelector(`.quantity-btn--increase[data-line-key="${lineKey}"]`);
        
        if (decreaseBtn) {
          decreaseBtn.disabled = currentValue <= minValue || isProcessing;
        }
        
        if (increaseBtn) {
          increaseBtn.disabled = currentValue >= maxValue || isProcessing;
        }
      } catch (error) {
        console.error('Error updating button states:', error);
      }
    });
  }

  
  refresh() {

    this.processing.clear();
    
    setTimeout(() => {
      this.bindEvents();
      this.updateButtonStates();
    }, 200);
  }
  

  safeRefresh() {

    this.processing.clear();
    

    setTimeout(() => {
      this.bindEvents();
      this.updateButtonStates();
    }, 500);
  }
}


let quantityControlsInstance = null;


function initQuantityControls() {
  if (quantityControlsInstance) {
    quantityControlsInstance.refresh();
  } else {
    quantityControlsInstance = new QuantityControls();
  }
}


function safeInitQuantityControls() {
  if (quantityControlsInstance) {
    quantityControlsInstance.safeRefresh();
  } else {
    quantityControlsInstance = new QuantityControls();
  }
}


document.addEventListener('DOMContentLoaded', initQuantityControls);


document.addEventListener('cart:updated', initQuantityControls);


if (typeof window.Shopify !== 'undefined') {
  document.addEventListener('cart.requestComplete', initQuantityControls);
  document.addEventListener('cart:build', initQuantityControls);
  document.addEventListener('cart:change', initQuantityControls);
}


document.addEventListener('cart:refresh', initQuantityControls);
document.addEventListener('cart:reload', initQuantityControls);
document.addEventListener('cart:rebuilt', initQuantityControls);


const observer = new MutationObserver((mutations) => {
  let shouldRefresh = false;
  
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
     
      const hasNewCartItems = Array.from(mutation.addedNodes).some(node => {
        return node.nodeType === 1 && (
          node.classList?.contains('line-item') ||
          node.querySelector?.('.quantity-btn')
        );
      });
      
      if (hasNewCartItems) {
        shouldRefresh = true;
      }
    }
  });
  
  if (shouldRefresh && quantityControlsInstance) {
    setTimeout(() => {
      quantityControlsInstance.refresh();
    }, 300);
  }
});


document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityControls);
} else {

  initQuantityControls();
}


window.addEventListener('load', initQuantityControls);


if (typeof window.Shopify !== 'undefined' && window.Shopify.onCartUpdate) {
  window.Shopify.onCartUpdate = function(cart) {
    setTimeout(initQuantityControls, 200);
  };
}

function removeTrailingZeros() {
  const totalPriceElement = document.querySelector('.cart-total-price');
  if (totalPriceElement) {
    let priceText = totalPriceElement.textContent.trim();

    const originalText = priceText;

    priceText = priceText.replace(/\.00(?=\s|$)/g, '');
    priceText = priceText.replace(/\.0(?=\s|$)/g, '');
    

    if (priceText !== originalText) {
      totalPriceElement.textContent = priceText;
    }
  }
}


document.addEventListener('DOMContentLoaded', function() {
  removeTrailingZeros();
  

  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {

        if (mutation.target.classList && mutation.target.classList.contains('cart-total-price')) {
          shouldUpdate = true;
        }

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('cart-total-price')) {
            shouldUpdate = true;
          }
        });
      }
    });
    
    if (shouldUpdate) {
      removeTrailingZeros();
    }
  });
  

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
/* #endregion ═════════════════════════════════════════════════════════════ */

/* ════════════════════════════════════════════════════════════════════════ */
/* #region(collapsed) Warranty Tooltip */
/**
 * Warranty tooltip open/close functionality
 */

document.addEventListener('click', function(e) {
  const tooltipTrigger = e.target instanceof Element && e.target.closest('.warranty-options-tooltip');
  if (tooltipTrigger) {
    const isHoverTooltip = tooltipTrigger.getAttribute('data-hover-tooltip') === 'true';
    // Only show popup if hover tooltip is disabled
    if (!isHoverTooltip) {
      e.preventDefault();
      e.stopPropagation();
      const warrantyBlock = tooltipTrigger.closest('.product-info__warranty');
      if (warrantyBlock) {
        const tooltip = document.querySelector('.product-warranty-tooltip');
        if (tooltip) {
          tooltip.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      }
    }
  }
});


document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('.product-warranty-tooltip__close');
  if (closeBtn) {
    e.preventDefault();
    e.stopPropagation();
    const tooltip = closeBtn.closest('.product-warranty-tooltip');
    if (tooltip) {
      tooltip.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
});


document.addEventListener('click', function(e) {
  const tooltip = e.target.closest('.product-warranty-tooltip');
  if (tooltip && e.target === tooltip) {
 
    e.preventDefault();
    e.stopPropagation();
    tooltip.classList.remove('active');
    document.body.style.overflow = '';
  }
});


document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const activeTooltip = document.querySelector('.product-warranty-tooltip.active');
    if (activeTooltip) {
      activeTooltip.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
});

// Hover tooltip functionality
document.addEventListener('mouseenter', function(e) {
  const tooltipTrigger = e.target instanceof Element && e.target.closest('.warranty-options-tooltip');
  if (tooltipTrigger) {
    const isHoverTooltip = tooltipTrigger.getAttribute('data-hover-tooltip') === 'true';
    if (isHoverTooltip) {
      const tooltipText = tooltipTrigger.querySelector('.warranty-options-tooltip__text');
      if (tooltipText) {
        tooltipTrigger.classList.add('warranty-options-tooltip--hover');
      }
    }
  }
}, true);

document.addEventListener('mouseleave', function(e) {
  const tooltipTrigger = e.target instanceof Element && e.target.closest('.warranty-options-tooltip');
  if (tooltipTrigger) {
    const isHoverTooltip = tooltipTrigger.getAttribute('data-hover-tooltip') === 'true';
    if (isHoverTooltip) {
      tooltipTrigger.classList.remove('warranty-options-tooltip--hover');
    }
  }
}, true);
/* #endregion ═════════════════════════════════════════════════════════════ */